function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2181px",
    height: "744px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#c51333",
    d: "M -0.5,-0.5 C 726.5,-0.5 1453.5,-0.5 2180.5,-0.5C 2180.5,247.5 2180.5,495.5 2180.5,743.5C 1453.5,743.5 726.5,743.5 -0.5,743.5C -0.5,495.5 -0.5,247.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#f5d9d0",
    d: "M 977.5,216.5 C 1018.67,215.833 1060,215.5 1101.5,215.5C 1143.17,215.5 1184.51,216.167 1225.5,217.5C 1142.9,216.503 1060.24,216.17 977.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1298.5,215.5 C 1371.83,215.333 1445.17,215.5 1518.5,216C 1544.2,220.702 1559.7,235.869 1565,261.5C 1565.67,334.167 1565.67,406.833 1565,479.5C 1562,507.833 1546.5,524.667 1518.5,530C 1445.17,530.667 1371.83,530.667 1298.5,530C 1271.02,524.85 1255.52,508.35 1252,480.5C 1251.33,408.833 1251.33,337.167 1252,265.5C 1255.69,237.654 1271.19,220.987 1298.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 316.5,215.5 C 402.833,215.5 489.167,215.5 575.5,215.5C 579.639,233.527 579.473,251.527 575,269.5C 569.96,287.487 558.46,298.654 540.5,303C 482.168,303.5 423.834,303.667 365.5,303.5C 365.5,313.167 365.5,322.833 365.5,332.5C 423.504,332.167 481.504,332.5 539.5,333.5C 545.351,355.844 542.851,377.177 532,397.5C 526.518,404.992 519.352,410.159 510.5,413C 462.213,414.481 413.88,414.981 365.5,414.5C 365.667,435.169 365.5,455.836 365,476.5C 359.741,505.093 342.907,522.593 314.5,529C 299.992,531.618 285.825,530.451 272,525.5C 271.333,437.5 271.333,349.5 272,261.5C 277.24,236.762 292.073,221.428 316.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M 696.5,303.5 C 695.506,312.986 695.173,322.652 695.5,332.5C 755.833,332.5 816.167,332.5 876.5,332.5C 880.605,349.203 880.438,365.87 876,382.5C 871.355,399.48 860.522,409.98 843.5,414C 794.168,414.5 744.834,414.667 695.5,414.5C 695.5,423.833 695.5,433.167 695.5,442.5C 765.5,442.5 835.5,442.5 905.5,442.5C 910.135,462.734 909.301,482.734 903,502.5C 898.141,515.359 889.308,524.192 876.5,529C 799.211,530.655 721.877,530.988 644.5,530C 620.124,523.291 605.957,507.458 602,482.5C 601.333,409.833 601.333,337.167 602,264.5C 605.948,237.219 621.448,221.052 648.5,216C 734.169,215.167 819.835,215.333 905.5,216.5C 909.637,234.212 909.47,251.879 905,269.5C 900.349,287.819 888.849,298.985 870.5,303C 812.501,303.5 754.501,303.667 696.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 977.5,216.5 C 1060.24,216.17 1142.9,216.503 1225.5,217.5C 1229.57,234.524 1229.4,251.524 1225,268.5C 1220.2,286.296 1209.04,297.796 1191.5,303C 1136.5,303.5 1081.5,303.667 1026.5,303.5C 1026.5,349.833 1026.5,396.167 1026.5,442.5C 1092.5,442.333 1158.5,442.5 1224.5,443C 1230.06,462.588 1229.56,482.088 1223,501.5C 1218.14,515.125 1208.97,524.291 1195.5,529C 1122.21,530.654 1048.88,530.987 975.5,530C 952.043,523.542 937.877,508.376 933,484.5C 932.333,409.833 932.333,335.167 933,260.5C 938.433,236.233 953.266,221.567 977.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1687.5,370.5 C 1687.44,369.957 1687.11,369.624 1686.5,369.5C 1685.5,403.827 1685.17,438.16 1685.5,472.5C 1682.3,504.202 1664.97,523.035 1633.5,529C 1619.92,530.38 1606.59,529.213 1593.5,525.5C 1592.33,440.502 1592.17,355.502 1593,270.5C 1597.78,247.4 1610.94,231.233 1632.5,222C 1657.93,213.483 1680.43,218.316 1700,236.5C 1737.71,280.706 1775.21,325.039 1812.5,369.5C 1812.78,370.289 1813.28,370.956 1814,371.5C 1814.5,334.502 1814.67,297.502 1814.5,260.5C 1818.4,233.766 1833.9,219.099 1861,216.5C 1887.55,219.052 1903.22,233.386 1908,259.5C 1908.67,330.167 1908.67,400.833 1908,471.5C 1907.09,489.155 1899.92,503.655 1886.5,515C 1868.79,527.787 1849.46,537.12 1828.5,543C 1781.61,485.377 1734.61,427.877 1687.5,370.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf6f5",
    d: "M 1951.5,216.5 C 1969.98,217.492 1978.81,227.158 1978,245.5C 1973.75,260.379 1963.92,266.879 1948.5,265C 1935.08,260.237 1928.91,250.737 1930,236.5C 1933.56,225.764 1940.73,219.097 1951.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c62036",
    d: "M 1949.5,222.5 C 1969.13,223.094 1975.97,232.761 1970,251.5C 1962.58,259.86 1953.74,261.693 1943.5,257C 1933.68,247.612 1933.01,237.612 1941.5,227C 1944.1,225.205 1946.77,223.705 1949.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf2f0",
    d: "M 1944.5,228.5 C 1949.18,228.334 1953.85,228.501 1958.5,229C 1965.7,233.432 1966.37,238.766 1960.5,245C 1962.02,247.024 1963.35,249.191 1964.5,251.5C 1962.5,252.833 1960.5,252.833 1958.5,251.5C 1957.79,246.781 1955.12,244.781 1950.5,245.5C 1950.5,247.833 1950.5,250.167 1950.5,252.5C 1948.5,252.5 1946.5,252.5 1944.5,252.5C 1944.5,244.5 1944.5,236.5 1944.5,228.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c62036",
    d: "M 1950.5,233.5 C 1952.86,233.337 1955.19,233.503 1957.5,234C 1959.62,235.523 1959.95,237.356 1958.5,239.5C 1955.91,240.48 1953.25,240.813 1950.5,240.5C 1950.5,238.167 1950.5,235.833 1950.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d25a55",
    d: "M 1814.5,260.5 C 1814.67,297.502 1814.5,334.502 1814,371.5C 1813.28,370.956 1812.78,370.289 1812.5,369.5C 1813.17,333.167 1813.83,296.833 1814.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c51433",
    d: "M 1353.5,303.5 C 1390.17,303.5 1426.83,303.5 1463.5,303.5C 1463.5,349.833 1463.5,396.167 1463.5,442.5C 1426.83,442.5 1390.17,442.5 1353.5,442.5C 1353.5,396.167 1353.5,349.833 1353.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d25954",
    d: "M 696.5,303.5 C 696.5,312.833 696.5,322.167 696.5,331.5C 756.669,331.168 816.669,331.501 876.5,332.5C 816.167,332.5 755.833,332.5 695.5,332.5C 695.173,322.652 695.506,312.986 696.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#f5dad2",
    d: "M 1687.5,370.5 C 1686.83,404.5 1686.17,438.5 1685.5,472.5C 1685.17,438.16 1685.5,403.827 1686.5,369.5C 1687.11,369.624 1687.44,369.957 1687.5,370.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.4c5bdc7ce7e39be18bf96879812e12a6.svg";
export { ForwardRef as ReactComponent };